import {Injectable, signal} from "@angular/core"
import type {Portal} from "@angular/cdk/portal"

@Injectable()
export class TemplateSidePanelService {
    readonly $portal = signal<Portal<unknown> | undefined>(undefined)
    readonly $open = signal(false)
}
